export default __webpack_public_path__ + "static/media/babylon_us_ios_app.6b6b9747.png";